import { createRoleThunks } from "./roleSliceFactory";
import { LAWYER_ENDPOINTS, ROLE_COLLECTION_KEYS } from "../types/roles";

const slice = createRoleThunks(
  "lawyer",
  LAWYER_ENDPOINTS,
  ROLE_COLLECTION_KEYS.lawyer
);

export const lawyerThunks = {
  fetchResource: slice.fetchResource,
  createResource: slice.createResource,
  updateResource: slice.updateResource,
  runAction: slice.runAction,
};

export const lawyerActions = slice.actions;

export default slice.reducer;
